<template>
  <div
    class="rounded-sm w-full bg-white p-4 pr-2 border-1px border-grey-field overflow-auto"
    :class="{ 'h-auto': open }">
    <div class="flex cursor-pointer" @click="$emit('click')">
      <span class="w-full text-grey-3 paragraph-2" data-test="privacyDropDown">
        Please read our privacy collection statement
      </span>
      <ChevronDown
        class="self-center mr-4 size-3"
        :class="{
          'transform rotate-180': open,
        }" />
    </div>
    <div
      v-if="open"
      class="mt-4 py-3 bg-blue-5 rounded px-4 text-grey-1 collapsible__content flex flex-col gap-3">
      <span>
        Otivo Pty Ltd ABN 47 602 457 732 (Otivo, we, us, or our) is committed to protecting your
        privacy. We collect your personal information from you (or your partner) when you (or your
        partner) register on, and use our platform to create financial plans.
      </span>
      <span>
        We use the personal information we collect for the purpose of providing advice on your
        financial situation. We do not trade, rent or sell your information or disclose it to any
        third parties.
      </span>
      <span>
        Our Privacy Policy contains more information about how to access and correct the information
        we hold about you and how to make a privacy related complaint. You can read it by visiting
        our website
        <!-- Hard coded for now -->
        <a href="/content/privacy" target="_blank"> Privacy Policy. </a>
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import ChevronDown from '@/components/icons/ChevronDown.vue'
import { WhitelabelDataType } from '@/types/WhiteLabelTypes.ts'
import { useSessionStore } from '@/store/pinia/SessionStore.ts'

type Prop = {
  open: boolean
}

withDefaults(defineProps<Prop>(), {
  open: false,
})
const sessionStore = useSessionStore()
const whitelabel = sessionStore.getWhitelabelData as WhitelabelDataType

defineEmits<{ (e: 'click'): void }>()
</script>

<style scoped></style>
